<template>
	<div class="page-tutorial">
	<div class="flex-column">

		<h2>Tutorial ({{tutorialEtapa+1}}/{{ tutorial.length }})</h2>

		<div class="tutorial">
			<figure v-if="tutorial[tutorialEtapa].imagem"><img :src="tutorial[tutorialEtapa].imagem" :key="tutorial[tutorialEtapa].imagem"></figure>
			<p v-html="tutorial[tutorialEtapa].texto"></p>
		</div>

		<div class="container">
			<div class="flex">
				<div>
					<button class="button" :disabled="tutorialEtapa==0" @click="tutorialEtapa = tutorialEtapa-1">Anterior</button>
					<button class="button" v-show="tutorialEtapa<tutorial.length-1" @click="tutorialEtapa = tutorialEtapa+1">Próximo</button>
					<button class="button" v-show="tutorialEtapa==tutorial.length-1" @click="goBack">Encerrar</button>
				</div>
				<span class="button" @click="goBack">Fechar</span>
			</div>
		</div>


	</div>
	</div>
</template>
<style>

.page-tutorial{padding:40px 20px; position: fixed; top: 0; bottom: 0; left: 0; right: 0; background: #fff; z-index: 10; }
.page-tutorial .flex-column { display: flex; flex-direction: column; }
.page-tutorial h2{ text-align: center; font-weight: bold; font-size: 20px; }
.page-tutorial p{}
.page-tutorial .tutorial { flex-grow: 1; display: flex; max-height:calc(100vh - 150px); }
.page-tutorial .tutorial figure {margin:20px 0; width:100%;}
.page-tutorial .tutorial figure img { height:100%; width:100%; display: block; object-fit: contain; }
.page-tutorial .tutorial p {}
.page-tutorial .flex { display: flex; justify-content: space-between; width:920px; max-width: 100%; }
.page-tutorial .button {}

</style>

<script>
import firebase from '@/firebase'
	export default {

		data(){
			return {
				tutorialEtapa:0,
				tutorial: [

				{imagem:'/images/tutorial/1.jpg',texto:''},
				{imagem:'/images/tutorial/2.jpg',texto:''},
				{imagem:'/images/tutorial/3.jpg',texto:''},
				{imagem:'/images/tutorial/4.jpg',texto:''},
				{imagem:'/images/tutorial/5.jpg',texto:''},
				{imagem:'/images/tutorial/6.jpg',texto:''},
				{imagem:'/images/tutorial/7.jpg',texto:''},
				],

			}
		},
		computed: {
        userId() {
            return this.$store.getters.userId;
        },
    },
		methods:{
        goBack(){
        		let db = firebase.firestore();
            db.collection('users').doc(this.userId).update({tutorialDone:true});
            this.$router.push({name:'home'});
        }
    },
	};
</script>
